export enum StowageChangeDataType {
    StowageItem = 1,
    BlockedTank = 2,
    AdjustedCargoTemperature = 3,
    Violation = 4,
    RotationPortCall = 5,
    RotationBerthCall = 6,
    RotationCargoOperation = 7,
    RotationCargo = 8,
}
